import { ILanguage, ILanguageExtended } from "@multiweb/types/contracts";
import { CancellationToken } from "../../../../../Global/Base/Promises/CancellationTokenSource";

/**
 * Umožňuje načítat informace o jazycích a kulturách a nastavovat jazyk, který má být použitý
 * @includeToDoc
 */
export interface ICultureClient {
    /**
     * Načte všechny dostupné jazyky a kultury pro aplikaci
     * @param cancellationToken Umožňuje zrušit běžící dotaz
     */
    getSupportedLanguages(cancellationToken?: CancellationToken): Promise<readonly ILanguageExtended[]>;

    /**
     * Získá jazyk a kulturu, které jsou nastavené pro aktuálního uživatele
     * @param cancellationToken Umožňuje zrušit běžící dotaz
     */
    getCurrentLanguage(cancellationToken?: CancellationToken): Promise<ILanguage>;

    /**
     * Nastaví jazyk, který se má uplatňovat pro aktuálního uživatele
     * @param code Kód jazyka v TescoSW formátu
     * @param cancellationToken Umožňuje zrušit běžící dotaz
     */
    setLanguage(code: string, cancellationToken?: CancellationToken): Promise<ILanguage>;

    /**
     * Uloží jazyk do profilu aktuálního uživatele
     * @param code Kód jazyka v TescoSW formátu
     * @param cancellationToken Umožňuje zrušit běžící dotaz
     */
    saveLanguageProfile(code: string, cancellationToken: CancellationToken): Promise<boolean>;

    /**
     * Načte jazyk z profilu aktuálního uživatele
     * @param cancellationToken Umožňuje zrušit běžící dotaz
     */
    loadLanguageProfile(cancellationToken: CancellationToken): Promise<string | null>;
}
